/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetupPasskeyRouteImport } from './routes/setup-passkey'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppApprovalsRouteImport } from './routes/_app/approvals'
import { Route as AppAssistantsRouteImport } from './routes/_app/assistants'
import { Route as AppLogRouteImport } from './routes/_app/log'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as AppTicketsIndexRouteImport } from './routes/_app/tickets/index'
import { Route as AppTicketsRefRouteImport } from './routes/_app/tickets/$ref'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupPasskeyRoute = SetupPasskeyRouteImport.update({
  id: '/setup-passkey',
  path: '/setup-passkey',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppAssistantsRoute = AppAssistantsRouteImport.update({
  id: '/assistants',
  path: '/assistants',
  getParentRoute: () => AppRoute,
} as any)
const AppLogRoute = AppLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => AppRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTicketsIndexRoute = AppTicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRefRoute = AppTicketsRefRouteImport.update({
  id: '/tickets/$ref',
  path: '/tickets/$ref',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-passkey': typeof SetupPasskeyRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRoute
  '/approvals': typeof AppApprovalsRoute
  '/assistants': typeof AppAssistantsRoute
  '/log': typeof AppLogRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/tickets/$ref': typeof AppTicketsRefRoute
  '/tickets/': typeof AppTicketsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-passkey': typeof SetupPasskeyRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRoute
  '/approvals': typeof AppApprovalsRoute
  '/assistants': typeof AppAssistantsRoute
  '/log': typeof AppLogRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/tickets/$ref': typeof AppTicketsRefRoute
  '/tickets': typeof AppTicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-passkey': typeof SetupPasskeyRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/assistants': typeof AppAssistantsRoute
  '/_app/log': typeof AppLogRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/_app/tickets/$ref': typeof AppTicketsRefRoute
  '/_app/tickets/': typeof AppTicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup-passkey'
    | '/account'
    | '/admin'
    | '/approvals'
    | '/assistants'
    | '/log'
    | '/oauth/consent'
    | '/tickets/$ref'
    | '/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup-passkey'
    | '/account'
    | '/admin'
    | '/approvals'
    | '/assistants'
    | '/log'
    | '/oauth/consent'
    | '/tickets/$ref'
    | '/tickets'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup-passkey'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/approvals'
    | '/_app/assistants'
    | '/_app/log'
    | '/oauth/consent'
    | '/_app/tickets/$ref'
    | '/_app/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupPasskeyRoute: typeof SetupPasskeyRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-passkey': {
      id: '/setup-passkey'
      path: '/setup-passkey'
      fullPath: '/setup-passkey'
      preLoaderRoute: typeof SetupPasskeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assistants': {
      id: '/_app/assistants'
      path: '/assistants'
      fullPath: '/assistants'
      preLoaderRoute: typeof AppAssistantsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/log': {
      id: '/_app/log'
      path: '/log'
      fullPath: '/log'
      preLoaderRoute: typeof AppLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/tickets/': {
      id: '/_app/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AppTicketsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/$ref': {
      id: '/_app/tickets/$ref'
      path: '/tickets/$ref'
      fullPath: '/tickets/$ref'
      preLoaderRoute: typeof AppTicketsRefRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAdminRoute: typeof AppAdminRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppAssistantsRoute: typeof AppAssistantsRoute
  AppLogRoute: typeof AppLogRoute
  AppTicketsRefRoute: typeof AppTicketsRefRoute
  AppTicketsIndexRoute: typeof AppTicketsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAdminRoute: AppAdminRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppAssistantsRoute: AppAssistantsRoute,
  AppLogRoute: AppLogRoute,
  AppTicketsRefRoute: AppTicketsRefRoute,
  AppTicketsIndexRoute: AppTicketsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupPasskeyRoute: SetupPasskeyRoute,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
